import * as React from 'react';
import { Link } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import actionTypes from '../../../../actions/ActionTypes';
import ReadersSidebar from './ReadersSidebar';
import ReaderStore from '../../../../stores/ReadersStore';
import { LoadReader, UpdateReader, DeleteReader } from '../../../../actions/ReadersActions';

const customHistory = createBrowserHistory();

class ReaderView extends React.Component {
  constructor(props) {
    super(props);
    // state
    this.state = {
      currentReader: undefined,
      showEditName: false,
      editName: '',
      isDirty: false,
      newMode: false,
      screenHeight: window.innerHeight - 150,
    };

    this.onReaderChange = this.onReaderChange.bind(this);
    this.updateReader = this.updateReader.bind(this);
    this.editReaderName = this.editReaderName.bind(this);
    this.toggleFieldSettings = this.toggleFieldSettings.bind(this);
    this.editLabel = this.editLabel.bind(this);
    this.addLabel = this.addLabel.bind(this);
    this.addValue = this.addValue.bind(this);
    this.removeLabel = this.removeLabel.bind(this);
    this.removeValue = this.removeValue.bind(this);
    this.editFieldName = this.editFieldName.bind(this);
    this.updateFieldSetting = this.updateFieldSetting.bind(this);
    this.update = this.update.bind(this);
    this.checkForUpdate = this.checkForUpdate.bind(this);
    this.showDeleteConfirm = this.showDeleteConfirm.bind(this);
    this.deleteReader = this.deleteReader.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.addFieldClick = this.addFieldClick.bind(this);
    this.deleteField = this.deleteField.bind(this);
  }

  componentDidMount() {
    ReaderStore.addChangeListener(this.onReaderChange);
    this.updateReader();
    document.title = 'TrinDocs - Readers'
  }

  componentWillUnmount() {
    ReaderStore.removeChangeListener(this.onReaderChange);
  }

  componentDidUpdate() {
    this.checkForUpdate();
  }

  onReaderChange() {
    let lastAction = ReaderStore.getLastAction();
    if (lastAction === actionTypes.GetReader) {
      console.log('GetReader');
        let reader = ReaderStore.getReader();
        if(reader !== undefined)
        {
            this.setState({currentReader: reader, newMode: false});
        }
    }
    if (lastAction === actionTypes.ReaderUpdate) {
      let reader = ReaderStore.getReader();

      if(reader !== undefined)
      {
          this.setState({currentReader: reader});
          let loc = window.location.pathname;
          let pathParts = loc.split('/');
          if(pathParts[pathParts.length - 1] === 'new')
            {

              customHistory.push(`/Admin/Readers/${reader.readerDBId}`);
              this.setState({newMode: false});
            }

      }
      console.log(reader);
    }
    if(lastAction === actionTypes.ReaderDelete)
    {
      let link = document.getElementById('readersHomeLink');
      link.click();
    }
  }

  checkForUpdate() {
    let loc = window.location.pathname;
    let pathParts = loc.split('/');
    let readerId = pathParts[pathParts.length - 1];
    let readerIdInt = parseInt(pathParts[pathParts.length - 1], 10);
    if (readerId !== 'new' && (isNaN(readerIdInt) || readerIdInt <= 0)) {
      return;
    }
    if (
      readerId === 'new' &&
      this.state.currentReader !== undefined &&
      this.state.currentReader.readerDBId !== -1
    ) {
      this.updateReader();
    }
    if (readerId !== 'new' &&
      this.state.currentReader !== undefined &&
      this.state.currentReader.readerDBId !== readerIdInt
    ){
      this.updateReader();
    }
  }

  editLabel(e, label) {
    let currentReader = this.state.currentReader;
    label.value = e.target.value;
    this.setState({currentReader: currentReader, isDirty: true});
  }



  editValue(e, val) {
    let currentReader = this.state.currentReader;
    val.value = e.target.value;
    this.setState({currentReader: currentReader, isDirty: true});
  }

  toggleFieldSettings(field) {
    let cr = this.state.currentReader;
    if(field.showSettings === true) {
        field.showSettings = false;
    }
    else {
        field.showSettings = true;
    }
    this.setState({currentReader: cr});

  }

  updateReader() {
    let loc = window.location.pathname;
    let pathParts = loc.split('/');
    if(pathParts[pathParts.length - 1] === 'new')
    {
      let newReader = {
        readerDBId: -1,
        readerName: '',
        fields: [],
      }
      this.setState({newMode: true, currentReader: newReader});
    } else {
      let readerId = parseInt(pathParts[pathParts.length - 1], 10);
      if(isNaN(readerId) || readerId <= 0)
      {
        customHistory.push('/Admin/Readers');
        return;
      }
      LoadReader(readerId);
    }


  }

  editReaderName(e) {
    let r = this.state.currentReader;
    r.readerName = e.target.value;
    this.setState({ currentReader: r, isDirty: true });
  }

  addLabel(field) {
    let r = this.state.currentReader;
    let nextId = -1;
    field.labels.forEach((l) => {
      if(l.valueId <= nextId) nextId--;
    })
    field.labels.push({
      valueId: nextId,
      value: ''
    });
    let newId = `${field.dbFieldId}_${nextId}`;
    this.setState({ currentReader: r, isDirty: true }, () => {
      let el =document.getElementById(newId);
      if(el) { el.focus(); }

     });
  }

  addValue(field) {
    let r = this.state.currentReader;
    let nextId = -1;
    field.values.forEach((l) => {
      if(l.valueId <= nextId) nextId--;
    })
    field.values.push({
      valueId: nextId,
      value: ''
    });
    let newId = `${field.dbFieldId}_${nextId}`;

    this.setState({ currentReader: r, isDirty: true }, () => {
      let el =document.getElementById(newId);
      if(el) { el.focus(); }
     });
    console.log(field);
  }

  removeLabel(field, label) {
    let r = this.state.currentReader;
    let idx = field.labels.indexOf(label);

    field.labels.splice(idx, 1);
    this.setState({ currentReader: r, isDirty: true });
  }

  removeValue(field, val) {
    let r = this.state.currentReader;
    let idx = field.values.indexOf(val);

    field.values.splice(idx, 1);
    this.setState({ currentReader: r, isDirty: true });
  }

  editFieldName(e, field){
    let r = this.state.currentReader;

    field.fieldName = e.target.value;
    this.setState({ currentReader: r, isDirty: true });
  }

  updateFieldSetting(e, field, setting)
  {
    if(setting === 'useDateFormat')
    {
      let r = this.state.currentReader;

      field.useDateFormat = e.target.checked;
      this.setState({ currentReader: r, isDirty: true });
    }

    if(setting === 'dateFormat')
    {
      let r = this.state.currentReader;
      field.dateFormat = e.target.value;
      this.setState({ currentReader: r, isDirty: true });
    }

      if(setting === 'removeDashes')
        {
          let r = this.state.currentReader;

          field.removeDashes = e.target.checked;
          this.setState({ currentReader: r, isDirty: true });
        }

      if(setting === 'removeSpaces')
        {
          let r = this.state.currentReader;

          field.removeSpaces = e.target.checked;
          this.setState({ currentReader: r, isDirty: true });
        }

      if(setting === 'removeCommas')
        {
          let r = this.state.currentReader;

          field.removeCommas = e.target.checked;
          this.setState({ currentReader: r, isDirty: true });
        }
      if(setting === 'monetize')
        {
          let r = this.state.currentReader;

          field.monetize = e.target.checked;
          this.setState({ currentReader: r, isDirty: true });
        }

  }

  update() {
    UpdateReader(this.state.currentReader);
  }

  showDeleteConfirm() {
    this.setState({deleteConfirm: true});
  }

  deleteReader() {
    DeleteReader(this.state.currentReader);
  }

  cancelDelete() {
    this.setState({deleteConfirm: false});
  }

  addFieldClick() {
    let current = this.state.currentReader;
    let newFieldId = -1;
    current.fields.forEach(x => {
      if(x.dbFieldId <= newFieldId) {
        newFieldId = x.dbFieldId - 1;
      }
    })
    let newField = {
      fieldName: '',
      dbFieldId: newFieldId,
      labels: [],
      values: [],
      showSettings: true
    }
    current.fields.push(newField);
    this.setState({currentReader: current});
  }

  deleteField(field) {
    field.isDeleted = true;
    this.setState({isDirty: true});
  }

  render() {
    return (
      <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <ReadersSidebar />
          {this.state.currentReader !== undefined && (
            <div
              className='flex-fill'
              style={{ backgroundColor: '#efefef', padding: '15px' }}
            >
              <div
                className='card'
                style={{
                  marginTop: '5px', height: `${this.state.screenHeight}px`
                }}
              >
                <div className='card-header'><h4 style={{float:'left'}}>Document Reader</h4>
                {this.state.isDirty &&
                <button className='btn btn-sm btn-success' style={{float: 'right'}} onClick={this.update}>Save Changes</button>
                }
                </div>
                <div className='card-body mb-2' style={{paddingRight:'6px', overflowY: 'auto'}}>
                <div className='col-6'>
                    <label>Name:</label>
                    <input
                      type='text'
                      className='form-control'
                      value={this.state.currentReader.readerName}
                      onChange={this.editReaderName}
                    ></input>
                  </div>
                {this.state.newMode === false &&
                  <div className='mt-4'>
                  <h5>Fields:</h5>

                  {this.state.currentReader.fields.map((field) => (
                    field.isDeleted !== true &&
                      <div key={field.dbFieldId}>
                      <table className='mb-2'>
                          <tbody>
                          <tr>
                              <td>
                                  <button className='btn btn-light btn-circle' style={{border: '1px solid #888'}} onClick={() => this.toggleFieldSettings(field)}><i
                                      className='fa-solid fa-rectangle-list'
                                      style={{ color: '#6CB5D0'  }}

                                      /></button>
                              </td>
                              <td>
                                  <span className='ps-2' style={{fontSize: '14pt'}}><strong>{field.fieldName}</strong></span>
                              </td>
                              <td>
                                  <button className='btn btn-sm btn-outline-danger btn-circle ms-3' onClick={() => this.deleteField(field)}><i
                                      className='fa-solid fa-times'
                                      /></button>
                              </td>
                          </tr>
                          </tbody>
                      </table>
                      {field.showSettings && <div className='card p-2 mb-4 pb-2'>
                          <div className='row ps-2'>
                              <div className='col-sm'>
                                  <div className='form-group row'>
                                  <label className='col-sm-1 col-form-label'>Name:</label>
                                  <div className='col-sm-4'>
                                  <input
                                          type='text'
                                          className='form-control form-control-sm'
                                          value={field.fieldName}
                                          onChange={(e) => this.editFieldName(e, field)}
                                  ></input>
                                  </div>
                                  </div>
                              </div>
                          </div>
                          <div className='row mt-2 ps-2 ms-2'>
                              <div className='col-sm-6'>
                                <div className='card'>
                                  <div className='card-body'>
                                    <h5>Label Finders:</h5>
                                  <div>
                                      {field.labels.map((label) => (
                                          <div className='pb-2 form-group row' key={label.valueId}>
                                            <div className='col-sm-10'>
                                              <input id={`${field.dbFieldId}_${label.valueId}`} className='form-control form-control-sm '
                                                value={label.value}
                                                onChange={(e) => this.editLabel(e, label)}
                                                >
                                              </input>
                                              </div>
                                              <div className='col-sm-2 p-0'>
                                              <button className='btn btn-sm btn-danger m-0'
                                                onClick={() => this.removeLabel(field, label)}>
                                                <i className='fa-solid fa-times' />
                                              </button>
                                              </div>
                                          </div>
                                      ))}
                                      <div><button
                                        className='btn btn-sm btn-success'
                                        onClick={() => this.addLabel(field)}>
                                          <i className='fa-solid fa-plus' />{' '}Add
                                        </button>
                                      </div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                              <div className='col-sm-6'>
                                  <div className='card'>
                                    <div className='card-body'>
                                      <h5>Value Finders:</h5>
                                      <div>
                                          {field.values.map((val) => (
                                              <div className='pb-2 form-group row' key={val.valueId}>
                                                <div className='col-sm-10'>
                                                  <input id={`${field.dbFieldId}_${val.valueId}`} className='form-control form-control-sm' value={val.value}
                                                    onChange={(e) => this.editValue(e, val)}
                                                    >
                                                  </input>
                                                </div>
                                                <div className='col-sm-2 p-0'>
                                                  <button className='btn btn-sm btn-danger m-0' onClick={() => this.removeValue(field, val)}>
                                                    <i className='fa-solid fa-times' />
                                                  </button>
                                                  </div>
                                              </div>

                                          ))}
                                          <div><button
                                            className='btn btn-sm btn-success'
                                            onClick={() => this.addValue(field)}
                                            >
                                              <i className='fa-solid fa-plus' />{' '}Add
                                            </button>
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                          </div>
                            <hr/>
                          <div className='row ps-4' >
                              <div className='col-sm'>
                                  <div className='form-check form-check-inline'>
                                      <input className='form-check-input' type='checkbox'
                                        checked={field.useDateFormat}
                                        onChange={(e) => this.updateFieldSetting(e, field, 'useDateFormat')}
                                      />
                                      <label className='form-check-label'>Use Date Format</label>
                                      <input
                                          type='text'
                                          className='form-control form-control-sm'
                                          value={field.dateFormat}
                                          onChange={(e) => this.updateFieldSetting(e, field, 'dateFormat')}


                                  ></input>
                                  </div>
                              </div>
                              <div className='col-sm'>
                                  <div className='form-check form-check-inline'>
                                      <input className='form-check-input' type='checkbox'
                                      checked={field.removeDashes}
                                      onChange={(e) => this.updateFieldSetting(e, field, 'removeDashes')}
                                      />
                                      <label className='form-check-label'>Remove dashes</label>
                                  </div>
                              </div>
                              <div className='col-sm'>
                                  <div className='form-check form-check-inline'>
                                      <input className='form-check-input' type='checkbox'
                                      checked={field.removeSpaces}
                                      onChange={(e) => this.updateFieldSetting(e, field, 'removeSpaces')}
                                      />
                                      <label className='form-check-label'>Remove spaces</label>
                                  </div>
                              </div>
                              <div className='col-sm'>
                                  <div className='form-check form-check-inline'>
                                      <input className='form-check-input' type='checkbox'
                                        checked={field.removeCommas}
                                        onChange={(e) => this.updateFieldSetting(e, field, 'removeCommas')}
                                      />
                                      <label className='form-check-label'>Remove commas</label>
                                  </div>
                              </div>
                              <div className='col-sm'>
                                  <div className='form-check form-check-inline'>
                                      <input className='form-check-input' type='checkbox'
                                        checked={field.monetize}
                                        onChange={(e) => this.updateFieldSetting(e, field, 'monetize')}
                                      />
                                      <label className='form-check-label'>Monetize</label>
                                  </div>
                              </div>
                          </div>


                      </div>}

                      </div>

                  ))}
                  <button className='btn btn-sm btn-success' onClick={this.addFieldClick}>Add Field</button>
                  </div>
                }
                </div>
              </div>
                {!this.state.deleteConfirm && <div>
                  {!this.state.newMode &&
                  <button className='btn btn-danger mt-2' onClick={this.showDeleteConfirm}>Delete Reader</button>
                  }
                </div>
                }
                {this.state.deleteConfirm &&
                <div className='alert alert-danger mt-2'>
                  This will delete the reader and any of its configurations.  Do you want to continue?
                  <button className='btn btn-danger ms-2' onClick={this.deleteReader}>Delete</button>
                  <button className='btn btn-secondary ms-2' onClick={this.cancelDelete}>Cancel</button>
                </div>
                }


            </div>
          )}
        </div>
        <Link
          id='readersHomeLink'
          to='/Admin/Readers'
          style={{ display: 'none' }}
        >
          HiddenLink
        </Link>
      </div>
    );
  }
}

export default ReaderView;
